import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import AileTerapisi from "../pages/aile-terapisi/page";
import CiftEvlilik from "../pages/cift-evlilik/page";
import BireyseldanismanlikPage from "../pages/bireysel-danismanlik/page";
import CocukErgenPage from "../pages/cocuk-ergen/page";
import CinselTerapiPage from "../pages/cinsel-terapi/page";
import BosanmaYasPage from "../pages/bosanma-yas/page";
import AdminLogin from "../pages/admin/login/page";
import AdminDashboard from "../pages/admin/dashboard/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/aile-terapisi",
    element: <AileTerapisi />,
  },
  {
    path: "/cift-evlilik-danismanligi",
    element: <CiftEvlilik />,
  },
  {
    path: "/bireysel-danismanlik",
    element: <BireyseldanismanlikPage />,
  },
  {
    path: "/cocuk-ergen-danismanligi",
    element: <CocukErgenPage />,
  },
  {
    path: "/cinsel-terapi",
    element: <CinselTerapiPage />,
  },
  {
    path: "/bosanma-yas-sureci",
    element: <BosanmaYasPage />,
  },
  {
    path: "/admin",
    element: <AdminLogin />,
  },
  {
    path: "/admin/dashboard",
    element: <AdminDashboard />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
